import React from 'react'

function Portfolio() {
  const websites = [
    { title: "Shri Shivaji Shikshan Prasarak Mandal, Goudgaon", img: "https://ssspmgoudgaon.com/public/logo.png", description:"", link: "#" },
    { title: "Nootan College Of Pharmacy", img: "https://nootanpharmacy.in/public/web/images/banner1.jpg", description:"", link: "#" },
    { title: "Raigad Institute of Nursing Education", img: "https://ayushhospitalaltus.com/public/ayush3.jpeg", description:"", link: "#" },
    { title: "Nootan School of Nursing", img: "https://www.nootannursing.in/public/web/images/building.jpg", description:"", link: "#" },
    { title: "Om College Of Nursing", img: "https://omcon.co.in/img/img.jpeg", description:"", link: "#" },
    { title: "Siddharth Public school, Jath", img: "https://siddharthpublicschooljath.org.in/public/upload/QYHPvOUHmLVT58VmS0gzGpdbzZ2ndxub3zXY1Lws.jpg", description:"", link: "#" },
    { title: "Nootan College Of Physiotherapy", img: "https://nootanpharmacy.in/public/web/images/banner1.jpg", description:"", link: "#" },
    { title: "SIDDHARTH POLYTECHNIC JATH", img: "https://spj.org.in/public/web/images/college.jpeg", description:"", link: "#" },
    { title: "Kamal Institute Of Nursing Education", img: "https://kineducation.co.in/public/upload/bmimIIsrFxOb0mI5Bh8nnRMtfUNWSAr7Tbz8O9J5.jpg", description:"", link: "#" },
    { title: "Mohan Mali International School & Jr. College", img: "https://www.mmischoolkm.com/public/web/img/school.png", description:"", link: "#" },
    { title: "Continental Institute Of Hotel Management & Catering Technology", img: "https://cihmctkolhapur.com/assets/images/building.png", description:"", link: "#" },
    { title: "Tuljapur Pujari", img: "https://tuljapurpujari.com/public/header1.jpeg", description:"", link: "#" },
    { title: "Ayush Hospital Altus", img: "https://ayushhospitalaltus.com/public/ayush3.jpeg", description:"", link: "#" },
    { title: "Pinnacle Adhaar", img: "https://ayushhospitalaltus.com/public/ayush3.jpeg", description:"", link: "#" },
    { title: "Dasara Executive Tuljapur", img: "https://firebasestorage.googleapis.com/v0/b/dasara-lodge.firebasestorage.app/o/galleries%2FMain%20Entrance.jpg-1738413012737?alt=media&token=2c4335d3-9618-4f4c-a645-6e79108be988", description:"", link: "#" },
    { title: "Nandini Executive Tuljapur", img: "https://nandiniexecutivetuljapur.com/public/img2.jpg", description:"", link: "#" },
    // Add more website projects here
  ];

  const softwareProjects = [
    { title: "Construction Mgmt", description: "Efficient construction project management software.", img: "assets/projects/construction.jpeg", link: "#" },
    { title: "Stone Crusher Mgmt", description: "Manage stone crusher operations seamlessly.", img: "assets/projects/crusher.jpeg", link: "#" },
    { title: "Milk Dairy Mgmt", description: "Automated milk dairy management system.", img: "assets/projects/dairy.jpeg", link: "#" },
    { title: "Temple Devotee Mgmt", description: "Manage temple devotees and events effectively.", img: "assets/projects/devotee.jpeg", link: "#" },
    { title: "Digital Mgmt", description: "Digital workflow management software.", img: "assets/projects/digital.jpeg", link: "#" },
    { title: "ERP Billing Mgmt", description: "ERP and billing solution for businesses.", img: "assets/projects/erp.jpeg", link: "#" },
    { title: "Hospital Mgmt", description: "Hospital management system.", img: "assets/projects/hospitals.jpeg", link: "#" },
    { title: "Lodge/Hotel Mgmt", description: "Hotel and lodge management software.", img: "assets/projects/hotel.jpeg", link: "#" },
    { title: "Restaurant/Bar Mgmt", description: "Restaurant and bar management solution.", img: "assets/projects/resto.jpeg", link: "#" },
    { title: "Laundry Mgmt", description: "Manage laundry operations efficiently.", img: "assets/projects/loundry.jpeg", link: "#" },
  ];

  const renderProjects = (projects) => {
    return projects.map((project, idx) => (
      <div key={idx} className="col-lg-3 wow fadeIn" data-wow-delay={`${0.2 * idx}s`}>
        <div className="case-item position-relative overflow-hidden rounded mb-2 shadow" style={{height:200}}>
          <img className="img-fluid" src={project.img} alt={project.title} />
          <a className="case-overlay text-decoration-none" href={project.link}>
            <small className="text-light">{project.title}</small>
            <h5 className="lh-base text-white mb-3">{project.description}</h5>
            <span className="btn btn-square btn-primary"><i className="fa fa-arrow-right" /></span>
          </a>
        </div>
      </div>
    ))
  }

  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start mb-lg-5">
              <h1 className="display-4 text-white mb-4 animated slideInRight">Our Portfolio</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Portfolio</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Explore our diverse portfolio of Websites and Software. Each project demonstrates innovation, quality, and client satisfaction.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="Portfolio Hero" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>

      {/* Portfolio Categories */}
      <div className="container-fluid bg-light py-5">
        <div className="container py-5">
          <div className="text-center mb-5">
            <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">Our Work</div>
            <h1 className="mb-4">Websites & Software</h1>
            <p className="text-muted mb-5">
              We create innovative solutions for clients worldwide. Explore our featured projects in each category.
            </p>
          </div>

          {/* Websites Section */}
          <h3 className="text-center mb-4">Websites</h3>
          <div className="row g-4 mb-5">
            {renderProjects(websites)}
          </div>

          {/* Software Section */}
          <h3 className="text-center mb-4">Software</h3>
          <div className="row g-4 mb-5">
            {renderProjects(softwareProjects)}
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="container-fluid bg-primary py-5">
        <div className="container text-center">
          <h2 className="text-white mb-4">Want to Discuss a Project?</h2>
          <p className="text-white-50 mb-2">
            Call us at <strong>+91 8459432930</strong> or email <strong>blueviperstechnology@gmail.com</strong>
          </p>
          <a href="/contact" className="btn btn-light rounded-pill px-4 py-2 mt-3">Contact Us</a>
        </div>
      </div>
    </div>
  )
}

export default Portfolio
